<template>
    <v-container pa-0 ma-0 fluid>
        <v-flex ref="home">
            <v-img
                    dark
                    :src="require('@/assets/img/innovation/johannes-plenio-fmTde1Fe23A-unsplash_cutted.jpg')"
            >
                <v-layout fill-height class="align-center ma-4 pa-4" >
                    <v-flex xs12>
                        <div :class="isMobile() ? 'display-1 font-weight-bold white--text text-shadow ntt_title': 'display-4 font-weight-bold white--text text-shadow ntt_title'">
                            NTT DATA Discovery
                        </div>
                        <br/>
                        <div :class="isMobile() ? 'headline font-weight-bold white--text text-shadow': 'display-2 font-weight-bold white--text text-shadow'">
                            Startup Collaboration Platform
                        </div>
                        <!--
                        <div :class="isMobile() ? 'title white--text text-shadow': 'display-2 font-weight-bold white--text text-shadow'">
                            Competition makes us Faster <br> Collaboration makes us Better
                        </div>
                        -->
                      <br/>
                      <br/>
                      <div :class="isMobile() ? 'headline white--text': 'display-1 white--text'">
                        Is your company not on Discovery yet? Find out what Discovery can do for you!
                      </div>
                      <br/>
                      <v-flex xs12 sm6 md5 lg3 class="ml-0 pr-2">
                        <v-btn class="elevation-3"
                               block
                               @mouseover="hover3 = true"
                               @mouseleave="hover3 = false"
                               color="white"
                               large
                               round
                               @click="goto('onboarding')"
                        >Onboarding
                        </v-btn>
                      </v-flex>

                        <v-layout row wrap class="mt-5">
                            <v-flex xs12>
                                <div :class="isMobile() ? 'headline white--text': 'display-1 white--text'">
                                    Our startup-related services:
                                </div>
                                <br/>
                            </v-flex>
                            <v-flex xs12 sm6 md5 lg3 class="ml-0 pr-2">
                                <v-btn class="elevation-3"
                                       block
                                       @mouseover="hover = true"
                                       @mouseleave="hover = false"
                                       color="white"
                                       :dark="!hover"
                                       :outline="!hover"
                                       @click="navigate('/discoverChallenges')"
                                >Discover challenges
                                </v-btn>
                            </v-flex>
                            <v-flex xs12 sm6 md5 lg3 class="ml-0 pr-2">
                                <v-btn
                                        block
                                        @mouseover="hover1 = true"
                                        @mouseleave="hover1 = false"
                                        class="elevation-3"
                                        color="white"
                                        :dark="!hover1"
                                        :outline="!hover1"
                                        @click="navigate('/startup/registration')"
                                >Register to NTT DATA Discovery
                                </v-btn>
                            </v-flex>

                            <v-flex v-if="tabletAndDown()" sm6 md5 lg3 xs12 class="ml-0 pr-2">
                                <v-btn
                                        block
                                        @mouseover="hover2 = true"
                                        @mouseleave="hover2 = false"
                                        class="elevation-3"
                                        color="white"
                                        :dark="!hover2"
                                        :outline="!hover2"
                                        @click="navigate('/startup/modification')"
                                >Edit your startup information
                                </v-btn>
                            </v-flex>
                        </v-layout>


                    </v-flex>
                </v-layout>

            </v-img>
        </v-flex>

        <v-container grid-list-sm text-xs-left>
          <v-flex xs12 py-2>
            <span class="display-2" ref="onboarding">Onboarding </span>
          </v-flex>
              <span style="font-size:18px;" >
                <strong>Discovery</strong> is a completely <strong><u>free of charge</u> platform</strong> that creates value for all the involved parties:
                <strong>startups, NTT DATA customers and NTT DATA itself</strong>. Discovery allows the startups of our network
                to <strong>be visible to the NTT DATA Group and to the related Customers</strong>,
                thereby increasing their chances to <strong>create business</strong>.

                <br>
                The process: for <strong>registering to the platform, startups have to fill the required fields</strong> with particular
                attention to the keywords and description fields. Hence, the NTT DATA Innovation Team receives the registration
                requests and <strong>schedules an assessment calls</strong> for confirming the information and accepting them in the network.

                <br>
                By being registered in the platform, startups can be engaged in <strong>commercial opportunities</strong>
                and <strong>apply to the challenges</strong>,
                Call4Ideas jointly launched by us and our partners and clients.
                <br>
                <br>
                  </span>

              <OnBoarding/>


  <!--style="position: fixed; bottom: 5%; right: 5%"-->


        </v-container>

        <!--<footer>
            <cookie-law theme="dark-lime"></cookie-law>
        </footer>-->
      <v-btn v-if="showBtn" class="elevation-3 onboarding" fab fixed right bottom
             pa-1
             block
             @mouseover="hover3 = true"
             @mouseleave="hover3 = false"
             color="white"

             round
             @click="goto('home')"
      ><v-icon dark large class="scroll-to-top" :class="{ 'animate': showIcon }">
        mdi-chevron-up
      </v-icon>
        Home & Register
      </v-btn>
    </v-container>

</template>


<script>
    import RouterService from "@/helpers/RouterService";
    import ServicesCategoriesInfo from "@/pages/Admin/ServicesCategories/ServicesCategoriesInfo";
    import UrlsService from "@/helpers/UrlsService";
    import TimeService from "@/helpers/TimeService";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
    import NotificationService from "@/helpers/NotificationService";
    import StateService from "@/helpers/StateService.js";
    import SettingsService from "@/helpers/SettingsService.js";

    import List from "@/components/Lists/List.vue";

    import OnBoarding from "@/pages/Admin/Innovation/PublicPages/OnBoarding.vue";


    export default {
        name: "HomePage",
        components: { OnBoarding, List },
        created(){

            StateService.resetAllVolatileData();
            SettingsService.save();

        },
        props: {
            isLogout: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                showIcon: false,
                hover:false,
                hover1:false,
                hover2:false,
                hover3:false,
                showBtn: false,
            };
        },
        mounted() {
            if (this.isLogout) {
                StateService.resetUserInfoAndSettings();
            }
            setInterval(() => {
              this.showIcon = !this.showIcon;
            }, 3000);
          window.addEventListener("scroll", this.isInViewport);
        },
        destroyed() {
          window.removeEventListener('scroll', this.isInViewport);
        },
        watch: {
          /*carouselInViewPort: {
            handler: function (value, newValue) {
            }
          }*/

        },
        methods: {
            isInViewport() {
              const rect = document.querySelector('.ntt_title').getBoundingClientRect();

              this.showBtn = !(rect.top >= 0 &&
                  rect.left >= 0 &&
                  rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                  rect.right <= (window.innerWidth || document.documentElement.clientWidth));
            },
            tabletAndDown() {
                return this.$vuetify.breakpoint.name === "xs" ||
                    this.$vuetify.breakpoint.name === "sm";
            },
            isMobile() {
                return this.$vuetify.breakpoint.name === "xs";
            },
            navigate(path) {
                RouterService.goTo(path);
            },

            goto(refName) {
              let element = this.$refs[refName];
              let top = element.offsetTop;
              window.scroll({left: 0, top: top, behavior: 'smooth'});
            }
        },
    };
</script>

<style lang="scss">


    .text-shadow{
        text-shadow: 2px 2px 2px rgb(0, 0, 0);
    }


    @keyframes scroll-up {
      0% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(-10px);
      }
      100% {
        transform: translateY(0);
      }
    }
    .scroll-to-top.animate {
      display: block;
      animation: scroll-up 1s ease-out infinite;
    }
    .onboarding {
      max-width: fit-content;
    }

    .divider {
      height: 2px;
      //width: 80%;
      alignment: center;
      color: grey;
      border-color: grey;
    }

</style>
